var exports = {
  "W": "shared.module__subsectionTitle___ZTZWYz",
};

module.exports = exports;
